<template>
	<div id="printMe" style="width: 100%;height: 100%;">
		<div class="d-flex m-3" style="justify-content: center;font-size: 18px;font-weight: 800;">QKERP 销售报价单</div>
		<div style="width: 100%;" class="d-flex m-3">
			<div style="width: 50%;">
				<div style="font-size: 14px;">NO.T12156</div>
				<div style="font-size: 14px;">客户：又是我</div>
				<div style="font-size: 14px;">报价：158645</div>
				<div style="font-size: 14px;">下单时间：2022-08-23 19:18:26</div>
			</div>
			<div style="width: 50%;">
				<div style="font-size: 14px;">发货仓库：天河奥特曼仓库</div>
				<div style="font-size: 14px;">产品数量：48925</div>
				<div style="font-size: 14px;">打印时间：2022-08-23 19:18:26</div>
			</div>
		</div>
		<div class="m-3" style="width: 100%;">
			<el-table :data="tableData" border style="width: 96%" size="mini" :cell-style="cellStyle" :header-cell-style="{color:'black',borderColor:'black'}">
				<el-table-column prop="name" label="产品名称" width="180"></el-table-column>
				<el-table-column prop="gg" label="规格名称" width="180"></el-table-column>
				<el-table-column prop="dw" label="单位"></el-table-column>
				<el-table-column prop="num" label="数量"></el-table-column>
			</el-table>
		</div>
		<div style="width: 100%;" class="d-flex m-3">
			<div style="width: 50%;">
				<div style="font-size: 14px;">部门：公司总部</div>
				<div style="font-size: 14px;">职员：你是谁</div>
			</div>
			<div style="width: 50%;">
				<div style="font-size: 14px;">备注：很多很多雨</div>
			</div>
		</div>
		<div><el-button type="primary" v-print="'#printMe'">立即创建</el-button></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			};
		},
		created() {
			// this.gotos()
		},
		methods: {
			gotos(e) {
				this.$router.push({
					name: 'zjb_dybb'
				});
			},
		}
	};
</script>

<style>
</style>